export const CLASSIC_CORRECTENGLISH_URL = !!(process.env.REACT_APP_CLASSIC_CORRECTENGLISH_URL)
                                        ? process.env.REACT_APP_CLASSIC_CORRECTENGLISH_URL
                                        : 'https://writing.correctenglish-staging.com';

export const API_BASE_URL = !!(process.env.REACT_APP_CE_API_DOMAIN)
                            ? process.env.REACT_APP_CE_API_DOMAIN
                            : "https://api.writeahead.com";

export const EXTENSION_CHROME_WEB_STORE_URL = !!(process.env.REACT_APP_EXTENSION_CHROME_WEB_STORE_URL)
                                        ? process.env.REACT_APP_EXTENSION_CHROME_WEB_STORE_URL
                                        : undefined;
export const EXTENSION_FIREFOX_WEB_STORE_URL = !!(process.env.REACT_APP_EXTENSION_FIREFOX_WEB_STORE_URL)
                                        ? process.env.REACT_APP_EXTENSION_FIREFOX_WEB_STORE_URL
                                        : undefined;
export const EXTENSION_SAFARI_WEB_STORE_URL = !!(process.env.REACT_APP_EXTENSION_SAFARI_WEB_STORE_URL)
                                        ? process.env.REACT_APP_EXTENSION_SAFARI_WEB_STORE_URL
                                        : undefined;
export const EXTENSION_EDGE_WEB_STORE_URL = !!(process.env.REACT_APP_EXTENSION_EDGE_WEB_STORE_URL)
                                        ? process.env.REACT_APP_EXTENSION_EDGE_WEB_STORE_URL
                                        : undefined;
export const EXTENSION_UNINSTALL_REDIRECT_URL = !!(process.env.REACT_APP_EXTENSION_UNINSTALL_REDIRECT_URL)
                                        ? process.env.REACT_APP_EXTENSION_UNINSTALL_REDIRECT_URL
                                        : "https://www.writeahead.com/uninstall";

export const USER_ACCOUNT_DELETION_REDIRECT_URL = !!(process.env.REACT_APP_USER_ACCOUNT_DELETION_REDIRECT_URL)
                                        ? process.env.REACT_APP_USER_ACCOUNT_DELETION_REDIRECT_URL
                                        : "https://writeahead.com/delete-account/";

export const FAQ_URL_URL = !!(process.env.REACT_APP_FAQ_URL)
    ? process.env.REACT_APP_FAQ_URL
    : "https://www.writeahead.com/faq";


export const SUPPORT_URL_URL = !!(process.env.REACT_APP_SUPPORT_URL)
    ? process.env.REACT_APP_SUPPORT_URL
    : "https://writeahead.com/support";

    export const RESEARCH_URL_URL = !!(process.env.REACT_APP_RESEARCH_URL)
    ? process.env.REACT_APP_RESEARCH_URL
    : "https://www.writeahead.com/our-research/";

export const CE_API_USERS_ROUTE = 'users';
export const CE_API_KEYCLOAK_USER_ROUTE = 'kcusers';
export const CE_BLOG_URL = 'https://www.correctenglish.com/blog';
export const FEEDBACK_URL = 'https://www.writeahead.com/feedback';
export const CE_USER_GUIDE = 'https://resource.vantage.com/display/CEWEB/CorrectEnglish+-+User+Guide';
export const WRITEAHEAD_PURCHASE_URL = 'https://www.writeahead.com/';
export const EXTENSION_PREMIUM_ROLES = ['ROLE_EXTENSION_PREMIUM_USER'];


export const SUBSCRIPTION_DURATION_KEY_NAME = 'subscriptionDuration';
export const STRIPE_SESSION_COOKIE_NAME = 'stripe-session';

export const ROISOURCE_KEY_NAME = 'rioSource';
export const ORDER_SOURCE_KEY_NAME = 'source';
export const PERSONA_KEY_NAME = 'persona';
export const INTENTION_KEY_NAME = 'intention';
export const CAMPAIGN_KEY_NAME = 'campaign';
export const REDIRECT_URL_KEY_NAME = 'redirect';
export const MARKETING_ATTRIBUTES_COOKIES_KEY_NAME = '_mktparam';

export const EX_PREMIUM_ECOMMERCE_SUBTYPE_NAME = 'WAEX PREMIUM';
export const EX_FREE_FOREVER_ECOMMERCE_SUBTYPE_NAME = 'WAEX FREE';
export const EX_INSTITUTE_PLAN_ECOMMERCE_SUBTYPE_NAME = 'WAEX PREMIUM for Institute';
export const BRAND_NAME = 'WriteAhead';

export const PRODUCT_PATH_PARAMETER_KEY_NAME = 'p';
export const PRODUCT_VERSION_KEY_NAME = 'v';

export const ExtensionStoreLinks = {
    "Chrome": EXTENSION_CHROME_WEB_STORE_URL,
    "Firefox": EXTENSION_FIREFOX_WEB_STORE_URL,
    "Safari": EXTENSION_SAFARI_WEB_STORE_URL,
    "Edge": EXTENSION_EDGE_WEB_STORE_URL
};

export const GOOGLE_TAG_URL = 'https://www.googletagmanager.com/gtag/js?id=G-188NG4FG1X';

export const API_AI_BASE_ENDPOINT = API_BASE_URL + "/api/ai";
export const API_AI_TEMPLATE_ENDPOINT = API_AI_BASE_ENDPOINT + "/template";
export const API_AI_TEMPLATE_LIST_ENDPOINT = API_AI_TEMPLATE_ENDPOINT + "/list";
export const API_AI_RUBRIC_ENDPOINT = API_AI_BASE_ENDPOINT + "/rubric";
export const API_AI_RUBRIC_ADMIN_ENDPOINT = API_AI_BASE_ENDPOINT + "/rubric/admin";
export const API_RUBRIC_LIST_ENDPOINT = API_AI_RUBRIC_ENDPOINT + "/list";
export const API_RUBRIC_LIST_FOR_NON_ADMIN_ENDPOINT = API_AI_RUBRIC_ENDPOINT + "/all";
export const API_AI_LLM_ENDPOINT = API_AI_BASE_ENDPOINT + "/llm";
export const API_AI_LLM_LIST_ENDPOINT = API_AI_LLM_ENDPOINT + "/list";
export const API_AI_LLM_FOR_NON_ADMIN_USER_ENDPOINT = API_AI_LLM_ENDPOINT + "/user";
export const API_ORGANIZATION_BASE_ENDPOINT = API_BASE_URL + "/api/groups";
export const API_ORGANIZATION_LIST_ENDPOINT = API_ORGANIZATION_BASE_ENDPOINT + "/list";
export const API_WA_PACKAGE_BASE_ENDPOINT = API_BASE_URL + "/api/wa-packages";
export const API_WA_PACKAGE_LIST_ENDPOINT = API_WA_PACKAGE_BASE_ENDPOINT + "/list";
export const API_AI_REPORT_ENDPOINT = "/api/ai/report";
export const API_REPORT_LIST_ENDPOINT = API_AI_REPORT_ENDPOINT + "/list";
export const API_REPORT_EXPORT_ENDPOINT = API_AI_REPORT_ENDPOINT + "/export";
export const API_AI_RESOURCE_ENDPOINT = API_AI_BASE_ENDPOINT + "/resource";
export const API_AI_ARTIFACT_ENDPOINT = API_AI_BASE_ENDPOINT + "/artifact";
export const API_AI_RESOURCE_FOR_ORG_ADMIN_ENDPOINT = API_AI_BASE_ENDPOINT + "/resource/admin/org";
export const API_ARTIFACT_DOWNLOAD_ENDPOINT = API_AI_ARTIFACT_ENDPOINT + "/download";
export const API_RESOURCE_DOWNLOAD_ENDPOINT = API_AI_RESOURCE_ENDPOINT + "/download";
export const API_AI_URL_RESOURCE_FOR_ORG_ADMIN_ENDPOINT = API_AI_BASE_ENDPOINT + "/resource/admin/org/urls";
export const API_AI_RESOURCE_ADMIN_ENDPOINT = API_AI_BASE_ENDPOINT + "/resource/admin";
export const API_RESOURCE_LIST_ENDPOINT = API_AI_RESOURCE_FOR_ORG_ADMIN_ENDPOINT + "/list";
export const API_AI_TAG_ENDPOINT = API_AI_BASE_ENDPOINT + "/tags";
export const API_FEEDBACK_ENDPOINT = API_BASE_URL + "/proxy/writingAnalyzer";
export const API_AI_TEXT_FEEDBACK_STREAM_ENDPOINT = API_FEEDBACK_ENDPOINT + "/stream-sse-mvc";
export const API_AI_FILES_FEEDBACK_STREAM_ENDPOINT = API_FEEDBACK_ENDPOINT + "/stream-file-native";
export const API_AI_BATCH_ID_FEEDBACK_STREAM_ENDPOINT = API_FEEDBACK_ENDPOINT + "/stream-file-batch";

export const API_REGISTRATION_ENDPOINT = API_BASE_URL + "/api/registration";
export const API_REGISTRATION_REDIRECT_URL = API_REGISTRATION_ENDPOINT + "/plan/register";

export const API_GRAMMAR_BASE_ENDPOINT = API_BASE_URL + "/proxy/grammar";
export const API_GRAMMAR_FILE_BATCH_SCORE_ENDPOINT = API_FEEDBACK_ENDPOINT + "/files-extract-score";

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '';
export const GOOGLE_DEVELOPER_KEY = process.env.REACT_APP_GOOGLE_DEVELOPER_KEY ?? '';
